export const getLocationOptions = () => ([
  {value: 'PARTNER', label: 'MX Partner Facility'},
  {value: 'HOME', label: 'Patient\'s Home'},
  // {value: 'GYM', label: 'Patient\'s Gym'},
  // {value: 'WORK', label: 'Patient\'s Workplace'},
  {value: 'VIRTUAL', label: 'Virtual'},
  {value: 'OTHER_MOBILE', label: 'Other Mobile Session'},
]);

export const formatOneLineAddress = addressData => {
  if (!addressData.address_line_1) return '';
  let str = addressData.address_line_1 ? `${addressData.address_line_1 } ` : '';
  str += `${addressData.address_line_2}`;
  str += ', ';
  str += addressData.address_city;
  str += ', ';
  str += addressData.address_state;
  str += ' ';
  str += addressData.address_zip;
  return str;
};
